import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { GOOGLE_RECAPTCHA_KEY },
} = getConfig();

/**
 * Custom hook which loads on initialization the script about
 * recaptcha. It takes as a parameter a boolean, fetchToken. When
 * this parameter is true then a request is done to google recaptcha in order
 * to fetch the required token.
 * Returns an array, array like the react hooks, with the recaptcha token.
 * @param fetchToken type of @boolean
 */
function useRecaptcha(fetchToken: boolean): [string, Dispatch<SetStateAction<string>>] {
  const [recaptchaToken, setRecaptchaToken] = useState('');
  /**
   * Creates recaptcha script
   * @param id type of @string
   * @param url type of @string
   */
  const loadScriptByURL = (id: string, url: string) => {
    const isScriptExist = document.getElementById(id);
    if (!isScriptExist) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  };

  /**
   * Function responsible to make the request for the recaptcha token
   */
  const requestRecaptchaToken = () => {
    window.grecaptcha.ready(async () => {
      try {
        const token: string = await window.grecaptcha.execute(GOOGLE_RECAPTCHA_KEY, { action: 'submit' });
        setRecaptchaToken(token);
      } catch (err) {
        console.error('Recaptcha cannot be touched');
      }
    });
  };

  useEffect(() => {
    /** TODO Move script to index */
    loadScriptByURL('recaptcha-key', `https://www.google.com/recaptcha/api.js?render=${GOOGLE_RECAPTCHA_KEY}`);
  }, []);

  useEffect(() => {
    if (fetchToken) {
      requestRecaptchaToken();
    }
  }, [fetchToken]);

  return [recaptchaToken, setRecaptchaToken];
}

export default useRecaptcha;
